module.exports = __webpack_public_path__ + "static/media/table_column_resize_width.e41c660d.png";